<template>
    <div class="content">
        <div v-for="(imgurl,index) in imgarr" :key="index" class="imglist">
            <img :src="imgurl" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                appTag:1,//app品牌 0 佳付通 1 富裕钱包 2我是队长
                activeUid:'',//活动id
                officeUid:'',
                imgarr:[],
            }
        },
        created () {
            let appTag = this.$route.query.appTag;
            if(!!appTag){
                this.appTag = appTag;
            }
            let activeUid = this.$route.query.activeUid;
            if(!!activeUid){
                this.activeUid = activeUid;
            }
            let officeUid = this.$route.query.officeUid;
            if(!!officeUid){
                this.officeUid = officeUid;
            }
            this.getMessage();//获取活动数据
        },
        methods: {
            getMessage() {
                var params = {};
                params["appTag"] = this.appTag;
                params["activeCode"] = this.activeUid;
                params["officeCode"] = this.officeUid;
                this.$baseUrl("active/v1/getActiveDetail4H5", params).then((res) => {
                    let data = res.data;
                    if (data.code == "0000") {
                        this.imgarr = data.activeDetailImgList;
                        document.title = data.activeName;
                    } else {
                        this.$toast(data.msg);
                    }
                });
            }
        },
    }
</script>

<style lang="scss" scoped>
.imglist{
    text-align: center;
}
.imglist img{
    max-width: 100%;
}
</style>